import type { EntityCardAccent } from "../../components/entityCard/EntityCard";
import { DisplayMode } from "../../data/BaseEntity";

export const DisplayModeAccent: Record<DisplayMode, EntityCardAccent | undefined> = {
  [DisplayMode.HISTORICAL]: "grey",
  [DisplayMode.WARNING]: "warning",
  [DisplayMode.OVERDUE]: "error",
  [DisplayMode.NORMAL]: undefined,
};
